// removed by extract-text-webpack-plugin
module.exports = {"loginInput":"Form__loginInput--KPJ8H","body":"Form__body--1pxmN","link":"Form__link--2IHmQ","forgotPasswordLink":"Form__forgotPasswordLink--4jW8i","loginFormInput":"Form__loginFormInput--349ci","footerSubmit":"Form__footerSubmit--3dEFG","footerLoginSubmit":"Form__footerLoginSubmit--Rj0AV","alertSuccess":"Form__alertSuccess--R97d1","alertError":"Form__alertError--3jiJY","form":"Form__form--1DtBW","error":"Form__error--2oZpd","input":"Form__input---c9pn","footer":"Form__footer--3gJ3V","alert":"Form__alert--3hjJk","flyoutValidation":"Form__flyoutValidation--1JELT"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/Form.scss
// module id = 68
// module chunks = 0